type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

export const DOCTOR_TODO_HEADERS: Header[] = [

  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "240px" },
    sortable: true,
  },

  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
   {
    key: "appointmentDateTime",
    label: "Appointment Date & Time",
    style: { width: "250px" },
    sortable: true,
  },
  {
    key: "locationofAppointment",
    label: "Location",
    style: { width: "250px" },
    sortable: true,
  },
  {
    key: "dictationId",
    label: "Dictations",
    style: { width: "50px" },
    isNumeric: true,
  },
  {
    key: "editorDueDateDesc",
    label: "Due Date",
    style: { width: "100px" },
    sortable: true,
  },
   { 
    key: "appointmentStatus",
    label: "Appointment Status",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "reportStatus",
    label: "Report Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "transcriptionFileName",
    label: "Transcription",
    style: { width: "120px", minWidth: "150px" },
    sortable: true,
  },
  {
    key: "assignedTo",
    label: "Assigned To",
    style: { width: "200px" },
    sortable: true,
  },
  {
    key: "dwcStatus",
    label: "DWC Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "150px" },
    sortable: true,
  },


];
export const EXPORT_DOCTOR_TODO_HEADERS: Header[] = [
  {
    key: "caseId",
    label: "Case ID ",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "140px" },
    sortable: true,
  },

  {
    key: "caseOrExamType",
    label: "Case / Exam Type",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "format_dueDate",
    label: "Due Date",
    style: { width: "100px" },
    sortable: true,
  },
  {
    key: "reportStatus",
    label: "Report Status",
    style: { width: "150px" },
    sortable: true,
  },
  {
    key: "appointmentDateTime",
    label: "Appointment Date & Time",
    style: { width: "200px" },
    sortable: true,
  },

  {
    key: "dwcStatus",
    label: "DWC Status",
    style: { width: "150px" },
    sortable: true,
  },

  {
    key: "assignedTo",
    label: "Assigned To",
    style: { width: "200px" },
    sortable: true,
  },
];

export const DICTATIONS_FILE_HEADERS: Header[] = [
  {
    key: "fileName",
    label: "Sr.No",
    sortable: false,
    style: { width: "30%" },
  },
  {
    key: "fileNameNew",
    label: "File Name",
    sortable: false,
    style: { width: "32%" },
  },
  {
    key: "download",
    label: "Action",
    style: { width: "10%" },
  },
];

export const DICTATIONS_VERSION_HEADER: Header[] = [
  { label: "Sr.No", key: "revisionNoDesc", style: { width: "25%" } },
  { label: "File Name", key: "fileNameNew" },
  { label: "Action", key: "download" },
];

export const PICKLIST_GROUP_NAME = {
  DWCExtensionStatus: "DWCExtensionStatus",
  DWCExtensionRequestedDays: "DWCExtensionRequestedDays",
  DWCExtension_30daysReasons: "DWCExtension_30daysReasons",
  DWCExtension_15daysReasons: "DWCExtension_15daysReasons",
};

export const LOG_HEADERS: Header[] = [
  { key: "newStatusName", label: "Stage" },
  { key: "who", label: "Who" },
  { key: "userRoleName", label: "Role" },
  { key: "when", label: "When" },
  { key: "newcomments", label: "Comment" },
];

export const APPROVAL_LIST_HEADERS: Header[] = [
  {
    key: "documentTypeName",
    label: "Document Type",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "documentCategory",
    label: "Document Category",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "headerModifiedByName",
    label: "Uploaded By",
    sortable: false,
    style: { width: "12%" },
  },
  {
    key: "headerUpdatedDate",
    label: "Uploaded On",
    sortable: false,
    style: { width: "14%" },
  },
  {
    key: "additionalComments",
    label: "Additional Comment",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "totalPageCount",
    label: "Total Pages",
    sortable: false,
    style: { width: "10%", textAlign: "right" },
  },
  {
    key: "fileAction",
    label: "File",
    sortable: false,
    style: { width: "5%" },
  },
  {
    key: "reportStatus",
    label: "Report Status",
    style: { width: "12%" },
  },
];

export const APPROVE_REWORK_LOGS_HEADERS: Header[] = [
  {
    key: "doctorQMEStatusName",
    label: "Report Status",
  },
  {
    key: "editorAssignedUserName",
    label: "Who",
  },
  {
    key: "createdByUserRole",
    label: "Role",
  },
  {
    key: "createdDateNew",
    label: "When",
  },
  {
    key: "editorComments",
    label: "Comments",
  },
];

export const DOCTOR_RECORD_LIST_HEADERS: Header[] = [
  {
    key: "documentTypeName",
    label: "Document Type",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "documentCategory",
    label: "Document Category",
    sortable: false,
    style: { width: "20%" },
  },
  {
    key: "uploadedByName",
    label: "Uploaded By",
    sortable: false,
    style: { width: "12%" },
  },
  {
    key: "uploadDateTimeNew",
    label: "Uploaded On",
    sortable: false,
    style: { width: "14%" },
  },
  {
    key: "commentes",
    label: "Additional Comment",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "noOfPages",
    label: "Total Pages",
    sortable: false,
    style: { width: "10%" },
  },
  {
    key: "fileAction",
    label: "File",
    sortable: false,
    style: { width: "10%" },
  },
];

export const DOCTOR_FILE_HEADERS: Header[] = [
  {
    key: "fileName",
    label: "File Name",
    sortable: false,
    style: { width: "30%" },
  },
  {
    key: "description",
    label: "Description",
    sortable: false,
    style: { width: "32%" },
  },
  {
    key: "uploadedByName",
    label: "Uploaded By",
    sortable: false,
    style: { width: "18%" },
  },
  {
    key: "uploadDateTimeNew",
    label: "Uploaded On",
    sortable: false,
    style: { width: "15%" },
  },
  {
    key: "download",
    label: "Action",
    style: { width: "10%" },
  },
];
